// extracted by mini-css-extract-plugin
export default {"button":"edit-notification-modal_button__FQtV-"};